export default "__VITE_ASSET__CMrJ8H5l__"